module.exports = __webpack_public_path__ + "static/media/bg-pattern-award-top.34a6ea1a.svg";